'use client'

import type React from 'react'
import { useCheckout, useModals } from '@/lib/hooks'

import { InputForm, ScrollArea } from '@/components/ui'
import { PaymentCard } from '@/components/molecules'

interface SelectPaymentCardTypeProps
  extends React.ComponentPropsWithoutRef<'form'> {
  onClose?: () => void
}

export const SelectPaymentCardType = ({
  onClose,
}: SelectPaymentCardTypeProps) => {
  const { setPaymentMethod, payment_methods, setCurrentStep } = useCheckout()
  const { openModal } = useModals()

  const handleSubmit = (_data: FormData) => {}

  const handleOnSelect = (method: any) => {
    setPaymentMethod(method)

    if (method?.last_digits_required) {
      openModal('PAYMENT_CARD_VERIFICATION')
    } else {
      onClose?.()
      setCurrentStep('COLLECT_PAYMENT')
    }
  }

  return (
    <form
      className="flex min-h-[280px] w-full flex-col gap-4 lg:flex-wrap"
      action={handleSubmit}
    >
      <ScrollArea className="w-full lg:max-h-[264px]">
        <div className="flex w-full flex-col gap-2">
          {payment_methods?.card?.map((card: any, index: number) => {
            return (
              <PaymentCard
                key={index}
                card={card}
                shortcut={index + 1}
                onClick={() => handleOnSelect(card)}
              />
            )
          })}
        </div>
      </ScrollArea>
    </form>
  )
}
